export default __webpack_public_path__ + "static/media/Main_slide.c643c502.png";